<template>

    <b-modal
        id="element-edit-modal"
        size="lg"
        :title="t.__('Edytuj materiały marketingowe')"
        :ok-title="t.__('Zapisz')"
        :cancel-title="t.__('Anuluj')"
        ok-variant="success"
        no-close-on-backdrop
        @shown="onModalShown"
        @ok="modalHandleOk"
        @hidden="modalHandleHide">

        <form @submit.prevent="submitForm" @keydown="form.errors.clear($event.target.name)" ref="element-form">

            <div class="row">
                <div class="col">
                    <p class="font-weight-bold mb-4" v-if="element">
                        <span v-if="type === 'area'">{{ t.__('Obszar') }}: </span>
                        <span v-if="type === 'package'">{{ t.__('Pakiet') }}: </span>
                        <span v-if="type === 'set'">{{ t.__('Zestaw') }}: </span>
                        <span v-if="type === 'game'">{{ t.__('Gra') }}: </span>
                        <span>{{ element.display_name }} ({{ element.output_identification_name }})</span>
                    </p>
                </div>
                <div class="col text-right">
                    <a href="#" class="btn btn-dark btn-sm" @click="switchToTranslateView">{{ t.__('Przełącz do widoku tłumaczenia') }}</a>
                    <a href="#" class="btn btn-info btn-sm" @click="switchToPreviewView">{{ t.__('Przełącz do widoku podglądu') }}</a>
                </div>
            </div>

            <div class="form-group">
                <label for="language">{{ t.__('Język') }}</label>
                <select class="form-control" id="language" v-model="language">
                    <option :value="null" disabled selected>{{ t.__('Wybierz') }}</option>
                    <option v-for="languagesOption in languagesOptions" :value="languagesOption.id">{{ languagesOption.text }}</option>
                </select>
            </div>

            <hr class="mb-4">

            <b-tabs pills card vertical nav-wrapper-class="col-3" v-if="form.marketing_resources.length" class="mb-3">
                <b-tab v-for="(marketingResource, index) in form.marketing_resources" :key="index" :title="marketingResource.section_name">
                    <b-card-text>
                        <div class="form-group">
                            <editor v-if="marketingResource.field_type === 'text' && editorActive" :init="editorInitConfig" :id="'marketing_resource_content_' + index" v-model="form.marketing_resources[index].content" @editorInit="e => e.setContent(form.marketing_resources[index].content)"></editor>
                            <input type="number" class="form-control" v-if="marketingResource.field_type === 'number'" :id="'marketing_resource_content_' + index" v-model="form.marketing_resources[index].content">
                            <span class="error mt-2 text-danger" v-if="form.errors.has('marketing_resources[' + index + '][content]')" v-text="form.errors.has('marketing_resources[' + index + '][content]')"></span>
                        </div>
                    </b-card-text>
                </b-tab>
            </b-tabs>

            <file-manager-browse :base-path="fileManagerPath" :button-text="t.__('Zarządzaj plikami')"></file-manager-browse>

        </form>

    </b-modal>

</template>

<script>

    import Editor from '@tinymce/tinymce-vue'

    export default {

        name: 'MarketingResourcesElementEditModal',

        components: {
            'editor': Editor
        },

        props: [
            'languages'
        ],

        data() {
            return {
                eventHub: window.eventHub,
                type: null,
                element: null,
                languagesOptions: [],
                language: 'pl',
                form: new Vue.prototype.Form({
                    marketing_resources: []
                }),
                fileManagerPath: null,
                editorActive: false,
                editorInitConfig: {
                    theme_url: '/assets/tinymce/themes/silver/theme.js',
                    skin_url: '/assets/tinymce/skins/ui/oxide',
                    skin: 'oxide',
                    content_css: '/assets/tinymce/skins/content/default/content.css',
                    language_url : '/assets/tinymce/langs/' + window.CONFIG.currentLocale + '.js',
                    language: window.CONFIG.currentLocale,
                    branding: false,
                    plugins: ['paste', 'print', 'searchreplace', 'autolink', 'visualblocks', 'visualchars', 'fullscreen',
                        'image', 'link',  'table', 'charmap', 'hr', 'nonbreaking', 'anchor', 'advlist', 'lists',
                        'wordcount', 'imagetools', 'help'],
                    toolbar: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat',
                    height: 400
                }
            }
        },

        watch: {
            language: function () {
                localStorage.setItem('marketingResourcesLang', this.language);
                this.load();
            }
        },

        beforeMount() {

            this.languages.forEach(language => {
                this.languagesOptions.push({
                    text: language.name,
                    id: language.code
                });
            });

        },

        mounted() {

            this.eventHub.$on('marketing-resources-edit', (type, element) => {
                if (![null, undefined, 'null', 'undefined'].includes(localStorage.getItem('marketingResourcesLang'))) {
                    this.language = localStorage.getItem('marketingResourcesLang');
                } else {
                    this.language = 'pl';
                }
                this.type = type;
                this.element = element;
                this.load();
            });

        },

        methods: {

            load() {
                this.eventHub.$emit('processing-start');
                axios.get(route('game::marketing-resources.get-element-resources', {elementType: this.type, elementId: this.element.id, language: this.language}))
                    .then(response => {
                        this.form = new Vue.prototype.Form({
                            marketing_resources: response.data.data.data.map(section => {
                                return {
                                    id: (section.resources !== null && section.resources[0] !== undefined) ? section.resources[0].id : null,
                                    section_id: section.id,
                                    section_name: section.name !== null ? section.name : ('(' + section.name_in_base_language + ')'),
                                    field_type: section.field_type,
                                    content: (section.resources !== null && section.resources[0] !== undefined) ? section.resources[0].content : '',
                                };
                            })
                        });
                        this.fileManagerPath = response.data.data.file_manager_path;
                        this.eventHub.$emit('processing-finish');
                        this.$bvModal.show('element-edit-modal');
                    })
                    .catch(error => {
                        console.log(error);
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', t.__('Coś poszło nie tak.'), 'error');
                    });
            },

            switchToTranslateView() {
                this.eventHub.$emit('marketing-resources-translate', this.type, this.element);
                this.$bvModal.hide('element-edit-modal');
            },

            switchToPreviewView() {
                this.eventHub.$emit('marketing-resources-preview', this.type, this.element);
                this.$bvModal.hide('element-edit-modal');
            },

            onModalShown() {
                this.editorActive = true;
            },

            modalHandleOk(event) {
                event.preventDefault();
                this.submitForm();
            },

            modalHandleHide() {
                this.type = null;
                this.element = null;
                this.form = new Vue.prototype.Form({
                    marketing_resources: []
                });
                this.editorActive= false;
            },

            submitForm() {
                this.eventHub.$emit('processing-start');
                this.form.put(route('game::marketing-resources.update-element-resources', {elementType: this.type, elementId: this.element.id, language: this.language}))
                    .then(response => {
                        this.$bvModal.hide('element-edit-modal');
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', response.message, 'success');
                    })
                    .catch(error => {
                        console.log(error);
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', t.__('Coś poszło nie tak. Sprawdź poprawność danych.'), 'error');
                    });
            }

        }

    }
</script>

<style scoped>

    /deep/ .nav.nav-pills .nav-item .nav-link {
        border-radius: .25rem;
    }

    /deep/ .nav.nav-pills .nav-item .nav-link.active {
        color: white;
    }

    /deep/ .tabs {
        border: 1px solid #e5e5e5;
        border-radius: .25rem;
    }

    /deep/ .tabs .tab-content {
        border: none;
        padding-top: 0;
    }

</style>
